import { render, staticRenderFns } from "./s4_index.vue?vue&type=template&id=adb061b6&scoped=true&"
import script from "./s4_index.vue?vue&type=script&lang=js&"
export * from "./s4_index.vue?vue&type=script&lang=js&"
import style0 from "./s4_index.vue?vue&type=style&index=0&id=adb061b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb061b6",
  null
  
)

export default component.exports